module.exports = __webpack_public_path__ + "img/Body_feathers_Normal.e1115be.png";